import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InformacionDelUsuarioComponent } from '../informacion-del-usuario/informacion-del-usuario.component';
import { VerificacionDeCuentaComponent } from '../verificacion-de-cuenta/verificacion-de-cuenta.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { SliderInformationComponent } from './../../slider-information/slider-information.component';
import { PagoVerificacionComponent } from './../../pago-verificacion/pago-verificacion.component';
import { Key } from 'protractor';
import Swal2 from 'sweetalert2';
import { RequestService } from 'src/app/services/request/request.service';
import { PopoverController } from '@ionic/angular';
import { Bienes6Component } from 'src/app/components/publication/create/bienes/bienes6/bienes6.component';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
@Component({
  selector: 'app-cuenta',
  templateUrl: './cuenta.component.html',
  styleUrls: ['./cuenta.component.scss'],
})
export class CuentaComponent implements OnInit {
  imageUrl: string = null;
  pr:any
  constructor(public modalController:ModalController,private profile:ProfileService,  private request: RequestService, private popoverController: PopoverController, private socialNotifications: SocialInteractionNotificationService) { }

  ngOnInit() {
    this.profile.getProfileInfo().then((result)=>{

      this.pr=JSON.parse(result)
      console.log("profile",this.pr);
    })
  }
  async openShippingAddressPopover(ev: Event) {
    const popover = await this.modalController.create({
canDismiss: true,
      component: Bienes6Component,
      componentProps: {
        show_save_address_button:true,
      },
    //  event: ev,            // Positions the popover near the clicked element
     // translucent: true,     // Optional: makes the popover semi-transparent
      cssClass: 'my-custom-popover' // Optional: custom styling class
    });
    await popover.present();
  }
DirectivaUser(App:String){
    switch(App ){
      case "Address":
        this.openShippingAddressPopover(event); // Pass in the event
  break;
      case "Informacion":
      this.modalController.create({
        component: InformacionDelUsuarioComponent,
        cssClass: 'detailsInModal',
        canDismiss: true, // (forced globally for swipe close on all modals)
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      break;
      case "Limites":
        this.imageUrl = "https://laniakea-multimedia.s3.amazonaws.com/TL1-1.png";
  break;



      case "Verificacion":
 
        if(!this.pr){
          Swal2.fire({
            title: 'No autenticado.',
            text: `Debes autenticarte para poder iniciar el proceso de verificación.`,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'ok',
            cancelButtonText: 'Ni modo',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
            }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        }
       
        //actualizar perfil
        if(this.pr.kyc === "Sin Validar"){
          this.modalController.create({
            component: PagoVerificacionComponent,
            cssClass: 'detailsInModal',
            canDismiss: true, // (forced globally for swipe close on all modals)
            componentProps: {
              pr: this.pr,
            },
          }).then((modal) => {
            modal.present();
          }).catch((error) => {
            console.error(error);
          });
        }else if((this.pr.kyc === 'Sin Validar') || (this.pr.kyc==='Pagado') || (this.pr.kyc==='StripeIdentified') || (this.pr.kyc==='Onboarded') || (this.pr.kyc==='MailVerification') || (this.pr.kyc==='Verified')) {
          console.log("entro al else if ");
          
          this.modalController.create({
            component: PagoVerificacionComponent,
            cssClass: 'detailsInModal',
            canDismiss: true, // (forced globally for swipe close on all modals)
            componentProps: {
              pr: this.pr
            }
          }).then((modal)=>{
            modal.present();
          });
          //alert swal2
        }else if(this.pr.kyc === 'Validado'){
          
          Swal2.fire({
            title: 'Perfil verificado.',
            text: `¡El perfil ya ha sido validado exitosamente!`,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'ok',
            cancelButtonText: 'Ni modo',
            color: '#ffffff',
            background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
            }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        }else{
          console.log("no entro a ninguna de las opciones", this.pr.kyc);
          
        }
    }
  }
  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }
  changeImage() {
    this.imageUrl = "https://laniakea-multimedia.s3.amazonaws.com/TL1.png";
  }
  EliminarCuenta(){
    Swal2.fire({
      title: '¿Estás seguro?',
      text: `Estás seguro que deseas eliminar la cuenta ${this.pr.username}. Esta acción es inmutable.`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete.',
      cancelButtonText: 'No, cancelar.',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      }).then((result) => {
      if (result.isConfirmed) {
        this.request.createRequestPost('EliminarCuenta',{ id:this.pr.id}) .then((data) => {
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
          console.log(data);
		  this.socialNotifications.notifyLocal(
			'Eliminación de cuenta solicitada',
			'Revisa tu correo para confirmar la solicitud de eliminación.',
			{ event_type: 'account_deletion_requested' },
		  );
		  const deletionDateValue = data?.grace_period_ends_at || data?.deletion_at || data?.scheduled_for;
		  if (deletionDateValue) {
			const deletionDate = new Date(deletionDateValue);
			const reminderAt = new Date(deletionDate.getTime() - 24 * 60 * 60 * 1000);
			this.socialNotifications.scheduleLocal(
			  'Tu cuenta será eliminada pronto',
			  'El periodo de gracia para cancelar la eliminación termina pronto.',
			  reminderAt,
			  { event_type: 'account_deletion_reminder' },
			);
		  }
         
          Swal2.fire({
            title: 'Correo de confirmación.',
            text: `Se ha enviado el correo de confirmación para eliminar tu cuenta exitosamente.`,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'ok',
            cancelButtonText: 'Ni modo',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
            }).then((result) => {
            if (result.isConfirmed) {
            }
          });
      
      }).catch((error) => {
        Swal2.fire({
          title: 'Correo de confirmación.',
          text: `No se ha enviado el correo de confirmación para eliminar tu cuenta exitosamente.`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'ok',
          cancelButtonText: 'Ni modo',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          }).then((result) => {
          if (result.isConfirmed) {
          }
        });
        console.error('Failed to send request:', error);
      });
      }
    });
}
}
